export const BaseURL = process.env.REACT_APP_API_BASE_URL;

export const HTTPService = {
  LOGIN: BaseURL + "/admin/login",
  GET_USER: BaseURL + "/user/",
  GET_ALL_USER_TYPES: BaseURL + "/admin/users",
  CREATE_AREA_MANAGER: BaseURL + "/admin/create/areamanager",
  UPDATE_AREA_MANAGER: BaseURL + "/admin/update/areamanager",
  DELETE_AREA_MANAGER: BaseURL + "/admin/delete/areamanager",
  DAILY: BaseURL + "/reports/daily",
  WEEKLY: BaseURL + "/reports/weekly",
  SAFETY: BaseURL + "/reports/safety",
  REPORTS_TRAINING: BaseURL + "/reports/training",
  REPORTS_OTHER_TRAINING: BaseURL + "/reports/other-training",
  EMPLOYEES: BaseURL + "/reports/employees",
  QUESTION_BY_CATEGORY: BaseURL + "/questions/questionsByCategory",
  EDIT_QUESTION: BaseURL + "/questions/edit",
  ADD_QUESTION: BaseURL + "/questions/add",
  GET_COMPANIES: BaseURL + "/appadmin/companies",
  ADD_COMPANY: BaseURL + "/appadmin/company/create",
  LIBRARY: BaseURL + "/library/verify",
  SET_PASSWORD: BaseURL + "/user/set-password",
  CHANGE_COMPANY_STATUS: BaseURL + "/appadmin/company/status",
  DELETE_COMPANY: BaseURL + "/appadmin/company",
  UPDATE_INTERNAL_TRAINING: BaseURL + "/admin/internalTraining",
  OTHER_TRAINING: BaseURL + "/externalTraining",
  PRODUCT_PROMOTION: BaseURL + "/promotions",
  PRODUCT_PROMOTION_IMAGES: BaseURL + "/promotions/images/admin",
  PDF_GENERATE: BaseURL + "/reports/pdf/generate",
  GALLERY: BaseURL + "/gallery/admin/",
  GET_ACCIDENT : BaseURL+'/accidents/',
  ACCIDENT_REPORT : BaseURL+'/accidents/report',
  SEND_NOTIFICATION : BaseURL+'/notifications/',
  CONTACT: BaseURL+'/contact-requests',
  FREE_TRIAL_REQUESTS: BaseURL + "/free-trial-requests",
  UPDATE_SUBSCRIPTION: BaseURL + "/appadmin/company/subscription",
  SEARCH: BaseURL + "/search",
  GET_RELEASE_HISTORY: BaseURL + "/appadmin/app-config/history",
  CREATE_RELEASE: BaseURL + "/appadmin/app-config/release",
  // v1 Billing & Plans
  BILLING_SUMMARY: BaseURL + "/api/v1/subscriptions/billing-summary",
  SUBSCRIPTION_CANCEL: BaseURL + "/api/v1/subscriptions/cancel",
  SUBSCRIPTION_REACTIVATE: BaseURL + "/api/v1/subscriptions/reactivate",
  SUBSCRIPTION_SETUP_AUTOPAY: BaseURL + "/api/v1/subscriptions/setup-autopay",
  SUBSCRIPTION_VERIFY: BaseURL + "/api/v1/subscriptions/verify",
  PLANS_PUBLIC: BaseURL + "/api/v1/plans/public",
  PLANS_CLIENT: BaseURL + "/api/v1/plans",
  PLANS_APPADMIN: BaseURL + "/api/v1/plans/appadmin",
  // v1 CRM
  CONTACT_REQUESTS: BaseURL + "/contact-requests",
  // Milestone 4
  INVOICES: BaseURL + "/api/v1/invoices",
  SAAS_NOTIFICATIONS: BaseURL + "/api/v1/notifications",
  WEBHOOK_EVENTS: BaseURL + "/api/v1/webhooks/events",
  BILLING_TIMELINE: BaseURL + "/api/v1/subscriptions/billing-timeline",
  SUBSCRIPTION_HISTORY: BaseURL + "/api/v1/subscriptions/history",
  APPADMIN_COMPANIES: BaseURL + "/api/v1/appadmin/companies",
  APPADMIN_COMPANY_OVERVIEW: BaseURL + "/api/v1/appadmin/companies", // + /:uuid/overview
  APPADMIN_TRIAL_DASHBOARD: BaseURL + "/api/v1/appadmin/trial-dashboard",
  APPADMIN_ANALYTICS: BaseURL + "/api/v1/appadmin/analytics",
};
